import React, { useState } from 'react';
import { Button } from 'antd';

import { FormattedMessage } from '../../util/reactIntl';
import TellNetworkModal from './TellNetworkModal';

/**
 * "Tell your sub-suppliers" on another company's job or RFP, for a supplier who manages its network:
 * the supplier's own Linked sub-suppliers the posting fits, with the customer's name left out unless
 * the supplier shows it. A sub-supplier told can read that one posting; it submits through the
 * supplier. The server decides whether the supplier can see the posting, and refuses one the supplier
 * was itself only forwarded.
 */
const TellSubSuppliersButton = ({ listingId, title, listingType }) => {
  const [open, setOpen] = useState(false);
  const isRfp = listingType === 'rfp_listing';
  return (
    <>
      <Button onClick={() => setOpen(true)}>
        <FormattedMessage id="TellNetworkModal.subSuppliersMenu" />
      </Button>
      {open ? (
        <TellNetworkModal
          open
          posting={{ id: listingId, title, listingType: isRfp ? 'rfp_listing' : 'job_listing' }}
          events={[isRfp ? 'rfpToSubSuppliers' : 'jobToSubSuppliers']}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </>
  );
};

export default TellSubSuppliersButton;
